import React from 'react';

export const CGU: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="text-4xl font-bold mb-8">Conditions Générales d'Utilisation</h1>
      
      <div className="prose max-w-none">
        <p className="text-gray-600 mb-6">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">1. Objet</h2>
          <p className="text-gray-700 leading-relaxed">
            Les présentes Conditions Générales d'Utilisation (ci-après « CGU ») ont pour objet de définir les modalités et conditions d'utilisation de la plateforme CoKilo, ainsi que les droits et obligations des utilisateurs.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">2. Acceptation des CGU</h2>
          <p className="text-gray-700 leading-relaxed">
            L'accès et l'utilisation de la plateforme CoKilo impliquent l'acceptation pleine et entière des présentes CGU. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser nos services.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">3. Description du service</h2>
          <p className="text-gray-700 leading-relaxed">
            CoKilo est une plateforme de mise en relation entre :
          </p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2 mt-3">
            <li>Les voyageurs disposant d'espace disponible dans leurs bagages</li>
            <li>Les expéditeurs souhaitant envoyer des colis</li>
          </ul>
          <p className="text-gray-700 leading-relaxed mt-3">
            CoKilo agit uniquement en tant qu'intermédiaire et ne prend pas en charge directement le transport des colis.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">4. Inscription et compte utilisateur</h2>
          <p className="text-gray-700 leading-relaxed mb-3">
            Pour utiliser la plateforme, vous devez :
          </p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>Être âgé d'au moins 18 ans</li>
            <li>Fournir des informations exactes et à jour</li>
            <li>Compléter la vérification d'identité via Stripe Identity</li>
            <li>Maintenir la confidentialité de vos identifiants</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">5. Obligations des utilisateurs</h2>
          
          <h3 className="text-xl font-semibold mt-4 mb-3">5.1 Pour les voyageurs</h3>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>Respecter le poids et les dimensions annoncés</li>
            <li>Transporter les colis avec soin</li>
            <li>Respecter les délais de livraison convenus</li>
            <li>Ne pas accepter de colis interdits ou dangereux</li>
          </ul>

          <h3 className="text-xl font-semibold mt-4 mb-3">5.2 Pour les expéditeurs</h3>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>Fournir une description exacte du colis</li>
            <li>Ne pas envoyer de marchandises interdites</li>
            <li>Emballer correctement les colis</li>
            <li>Respecter les réglementations douanières</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">6. Marchandises interdites</h2>
          <p className="text-gray-700 leading-relaxed mb-3">
            Il est strictement interdit de transporter :
          </p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>Substances illégales ou stupéfiants</li>
            <li>Armes et munitions</li>
            <li>Produits dangereux, inflammables ou explosifs</li>
            <li>Argent liquide en grande quantité</li>
            <li>Objets volés ou contrefaits</li>
            <li>Produits périssables sans emballage approprié</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">7. Paiements et commission</h2>
          <p className="text-gray-700 leading-relaxed">
            Les paiements sont traités de manière sécurisée via Stripe. CoKilo prélève une commission de 30% sur chaque transaction. Pour les utilisateurs algériens, les paiements sont gérés via un système de wallet virtuel avec virements manuels.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">8. Responsabilité</h2>
          <p className="text-gray-700 leading-relaxed">
            CoKilo agit en tant qu'intermédiaire et ne peut être tenu responsable des dommages, pertes ou retards liés au transport des colis. Une assurance optionnelle est disponible pour protéger vos envois.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">9. Résiliation</h2>
          <p className="text-gray-700 leading-relaxed">
            CoKilo se réserve le droit de suspendre ou résilier tout compte en cas de violation des présentes CGU, sans préavis ni indemnité.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">10. Modification des CGU</h2>
          <p className="text-gray-700 leading-relaxed">
            CoKilo se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs seront informés des modifications par email ou via l'application.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">11. Contact</h2>
          <p className="text-gray-700 leading-relaxed">
            Pour toute question concernant ces CGU, veuillez nous contacter via notre formulaire de contact.
          </p>
        </section>
      </div>
    </div>
  );
};